// @flow

export const MODEL = 'ContactUs'

// Api End Point
export const URL = 'hefty/contactus/'

// Model Properties
export const PROP_NAME = 'name'
export const PROP_EMAIL = 'email'
export const PROP_SUBJECT = 'subject'
export const PROP_MESSAGE = 'message'
